module.exports = __webpack_public_path__ + "img/btn-spotify.74e72b6d.jpg";